/** Synchronous journal for the small UI batching window, before HTTP is queued. */
export class TapDraftJournal {
  #key = "";
  #drafts: Record<string, number> = {};
  open(scope: string): void {
    this.#key = `diamond-kingdom:tap-drafts:${scope}`;
    this.#drafts = {};
    try {
      const raw: unknown = JSON.parse(localStorage.getItem(this.#key) ?? "{}");
      if (raw && typeof raw === "object" && !Array.isArray(raw)) {
        for (const [id, count] of Object.entries(raw)) {
          if (/^[\w:-]{1,160}$/.test(id) && Number.isSafeInteger(count) && Number(count) > 0 && Number(count) <= 500) this.#drafts[id] = Number(count);
        }
      }
    } catch { /* The durable outbox remains the IndexedDB fallback. */ }
  }
  entries(): [string, number][] { return Object.entries(this.#drafts); }
  put(id: string, count: number): void { if (this.#key) { this.#drafts[id] = count; this.#save(); } }
  remove(id: string): void { this.#drafts = Object.fromEntries(Object.entries(this.#drafts).filter(([key]) => key !== id)); this.#save(); }
  #save(): void {
    try { localStorage.setItem(this.#key, JSON.stringify(this.#drafts)); }
    catch { /* Blocked browser storage cannot survive a hard WebView kill. */ }
  }
}
